import React, { useState } from 'react';
import './DonationPage.css';
import { Container, Row, Col, Card, CardBody, Table, ListGroup, ListGroupItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlag, faHeart, faUniversity, faQrcode, faImages } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import Qrcode from './../../assets/qrcode.png';
import { useLocation } from 'react-router-dom';
import img from "./../../assets/Flag1.jpg";
import img1 from "./../../assets/flag2.jpg";
import img2 from "./../../assets/flag3.jpg";
import img3 from "./../../assets/flag4.jpg";
import img4 from "./../../assets/flag5.jpg";

const DonationPage = () => {
  const [items, setItems] = useState([ {
      src: img,
      key: 1,
    },
    {
      src: img1,
      key: 2,
    },
    {
      src: img2,
      key: 3,
    },
    {
      src: img3,
      key: 3,
    },
    {
      src: img4,
      key: 3,
    },
  ]);
    const [loading, setLoading] = useState(false);
    return (
      <>
        <div style={{
          backgroundImage: `url(${footerBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '30px 0',
          color: 'white',
          margin: '2%',
          borderRadius: '10px'
        }}>
          <Container>
            <h3 className="fw-bold mb-0 text-center">
              <FontAwesomeIcon icon={faFlag} className="me-2" />
              Armed Forces Flag Day Fund
            </h3>
          </Container>
        </div>

        <Container className="py-5">
           

          <Row className="mb-5">
            <Col lg={12} className="mb-4">
              <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(142,68,173,0.15)' }}>
                <div style={{
                  background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                  padding: '25px',
                  color: 'white'
                }}>
                  <h4 className="fw-bold mb-0">
                    <FontAwesomeIcon icon={faFlag} className="me-2" />
                    About Armed Forces Flag Day
                  </h4>
                </div>
                <CardBody className="p-4">
                  <p style={{ color: '#495057', lineHeight: '1.8', textAlign: 'justify' }}>
                    Armed Forces Flag Day is observed on 7th December every year, since 1949, to honour Indian Armed Forces personnel. The day includes the distribution of Token Flags & Car Stickers to raise funds. It is a time to express gratitude to current and veteran military personnel, and honor those who died in service.
                  </p>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row className="mb-5">
            <Col lg={12} className="mb-4">
              <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                <div style={{
                  background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                  padding: '25px',
                  color: 'white'
                }}>
                  <h4 className="fw-bold mb-0">
                    <FontAwesomeIcon icon={faHeart} className="me-2" />
                    Armed Forces Flag Day Fund
                  </h4>
                </div>
                <CardBody className="p-4">
                  <p style={{ color: '#495057', lineHeight: '1.8', textAlign: 'justify' }}>
                    The Armed Forces Flag Day Fund (AFFDF) was officially constituted on April 13, 1993 by the Government of India through a Ministry of Defence notification to unify various welfare funds for ESM, war widows and their dependents.
                  </p>
                  <p style={{ color: '#495057', lineHeight: '1.8' }}>
                    <strong>Three Fixed Deposits of Rs 20 Lakh each are maintained for this purpose.</strong>
                  </p>
                  
                  <h5 className="fw-bold mt-4 mb-3" style={{ color: '#8e44ad' }}>
                    The significance and primary purpose for collection of funds on Flag day is as under:
                  </h5>
                  <ListGroup flush>
                    <ListGroupItem className="px-0 py-2 border-0" style={{ color: '#495057' }}>
                      <FontAwesomeIcon icon={faHeart} className="me-2" style={{ color: '#8e44ad' }} />
                      Re-habilitation of Battle Casualties
                    </ListGroupItem>
                    <ListGroupItem className="px-0 py-2 border-0" style={{ color: '#495057' }}>
                      <FontAwesomeIcon icon={faHeart} className="me-2" style={{ color: '#8e44ad' }} />
                      Re-settlement and welfare of Ex-Servicemen and their families
                    </ListGroupItem>
                    <ListGroupItem className="px-0 py-2 border-0" style={{ color: '#495057' }}>
                      <FontAwesomeIcon icon={faHeart} className="me-2" style={{ color: '#8e44ad' }} />
                      Welfare of serving personnel and their families
                    </ListGroupItem>
                  </ListGroup>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row className="mb-5">
            <Col md={6}>
              <Card className="h-100 border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(22,160,133,0.15)' }}>
                <div style={{
                  background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                  padding: '25px',
                  color: 'white'
                }}>
                  <h4 className="fw-bold mb-0">
                    <FontAwesomeIcon icon={faUniversity} className="me-2" />
                    Mode of Contribution
                  </h4>
                </div>
                <CardBody className="p-4">
                  <p style={{ color: '#495057' }}>By Cheque/Demand draft drawn in favour of Secretary, Rajya Sainik Board</p>
                  
                  <Table style={{marginTop:'5%',wordBreak:"break-word"}} bordered hover>
                    <tbody>
                      <tr>
                        <th scope="row" style={{ background: '#f8f9fa', color: '#1e3c72' }}>Bank Name:</th>
                        <td style={{ color: '#495057' }}>State Bank Of India</td>
                      </tr>
                      <tr>
                        <th scope="row" style={{ background: '#f8f9fa', color: '#1e3c72' }}>Account Name:</th>
                        <td style={{ color: '#495057' }}>Secretary, Rajya Sainik Board,<br/> Flag Day Fund</td>
                      </tr>
                      <tr>
                        <th scope="row" style={{ background: '#f8f9fa', color: '#1e3c72' }}>Account Number:</th>
                        <td style={{ color: '#495057' }}>65271499108</td>
                      </tr>
                      <tr>
                        <th scope="row" style={{ background: '#f8f9fa', color: '#1e3c72' }}>Branch :</th>
                        <td style={{ color: '#495057' }}>Sector 12 Panchkula</td>
                      </tr>
                      <tr>
                        <th scope="row" style={{ background: '#f8f9fa', color: '#1e3c72' }}>IFSC Code:</th>
                        <td style={{ color: '#495057' }}>SBIN 0050726</td>
                      </tr>
                      <tr>
                        <th scope="row" style={{ background: '#f8f9fa', color: '#1e3c72' }}>Contact Details<br/> & Email:</th>
                        <td style={{ color: '#495057' }}>01722560462, Superintendentone@gmail.com</td>
                      </tr>
                      
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="h-100 border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                <div style={{
                  background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                  padding: '25px',
                  color: 'white'
                }}>
                  <h4 className="fw-bold mb-0">
                    <FontAwesomeIcon icon={faQrcode} className="me-2" />
                    Online Payment
                  </h4>
                </div>
                <CardBody className="p-4 text-center">
                  <h5 style={{ color: '#1e3c72' }} className="fw-bold mb-2">Pay Online through our website</h5>
                  <p style={{ color: '#6c757d' }}>BY UPI SCAN</p>
                  <div className='mt-4' style={{ padding: '20px', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)', borderRadius: '10px' }}>
                    <img style={{width:'80%', height:'auto'}} src={Qrcode} alt="UPI QR Code" className="img-fluid" />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          
          <Row className="mt-5">
            <Col lg={12}>
              <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(142,68,173,0.15)' }}>
                <div style={{
                  background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                  padding: '25px',
                  color: 'white'
                }}>
                  <h4 className="fw-bold mb-0">
                    <FontAwesomeIcon icon={faImages} className="me-2" />
                    Flag Day Celebration
                  </h4>
                </div>
                <CardBody className="p-4">
                  <div className="row justify-content-center">
                    {items.length > 0 &&
                      items.map((img) => (
                        <div className="col-lg-4 mb-3" key={img.key}>
                          <div
                            className="mx-2"
                            style={{
                              boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 8px 0px",
                              borderRadius: "8px",
                              overflow: "hidden",
                              height: "300px"
                            }}
                          >
                            <img
                              src={img.src}
                              alt="Flag Day"
                              className="school-image"
                              width="100%"
                              height="100%"
                              style={{ borderRadius: "8px" ,display:'block',objectFit:'cover'}}
                            />
                          </div>
                        </div>
                      ))}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
};

export default DonationPage;
